module.exports = __webpack_public_path__ + "img/interpeople1_50_40.65b5ba2e.png";